import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import FavoriteIcon from "@material-ui/icons/Favorite";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import TwitterIcon from "@material-ui/icons/Twitter";
import { Icon } from "@iconify/react";
import bitcoinIcon from "@iconify-icons/mdi/bitcoin";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import YouTubeIcon from "@material-ui/icons/YouTube";
import React, { lazy, Suspense } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const renderLoader = () => <CircularProgress color="secondary" />;

const YouTube = lazy(() => import("react-youtube"));

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tabpanel-${index}`,
    "aria-controls": `scrollable-prevent-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    overflowX: "auto",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 30,
      width: "100%",
      backgroundColor: "#635ee7",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab {...props} />);

export default function TabSlides() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const opts = {
    height: "100%",
    width: "100%",
  };
  return (
    <div className={classes.root}>
      <Paper elevation={15} style={{ minHeight: "60vh" }}>
        <AppBar position="static" color="default">
          <StyledTabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="secondary"
            aria-label="tabs"
          >
            <StyledTab
              label={`${t("tabslides.video")}`}
              icon={<YouTubeIcon />}
              {...a11yProps(0)}
            />
            <StyledTab
              label={`${t("tabslides.select")}`}
              icon={<FavoriteIcon />}
              {...a11yProps(1)}
            />
            <StyledTab
              label={`${t("tabslides.tweet")}`}
              icon={<TwitterIcon />}
              {...a11yProps(2)}
            />
            <StyledTab
              label={`${t("tabslides.getcrypto")}`}
              icon={<Icon icon={bitcoinIcon} style={{ fontSize: "2em" }} />}
              {...a11yProps(3)}
            />
          </StyledTabs>
        </AppBar>
        {value === 0 ? (
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            alignContent="center"
            wrap="nowrap"
            style={{
              backgroundColor: "#2A4EA6",
              minHeight: "60.2vh",

              color: "#ddd",
            }}
          >
            <Grid item xs={12} sm={12} lg={12} md={12}>
              <Suspense fallback={renderLoader()}>
                <YouTube videoId="T7JS4L49TL4" opts={opts} />
              </Suspense>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <TabPanel
          value={value}
          index={1}
          style={{
            backgroundColor: "#2A4EA6",
            minHeight: "60.2vh",
            color: "#ddd",
          }}
        >
          {t("tabslides.everyweek")}
        </TabPanel>

        <TabPanel
          value={value}
          index={2}
          style={{
            backgroundColor: "#0081AF",
            minHeight: "60.2vh",
            color: "#ddd",
          }}
        >
          {t("tabslides.nowmakeatweet")}
        </TabPanel>
        <TabPanel
          value={value}
          index={3}
          style={{
            backgroundColor: "#6BA7C7",
            minHeight: "60.2vh",
            color: "#ddd",
          }}
        >
          {t("tabslides.submiturl")}
        </TabPanel>
      </Paper>
    </div>
  );
}
